import styled from 'styled-components'

export const HoverTooltip = styled.div`
  position: absolute;
  top: calc(100% + 2px);
  left: 0;
  right: auto;
  bottom: auto;

  transform: none;
  z-index: 100;
  opacity: 0;
  visibility: hidden;
  pointer-events: none;
  transition:
    opacity 0.2s ease,
    visibility 0.2s ease;

  &::before {
    content: '';
    position: absolute;
    top: -10px;
    left: 0;
    right: 0;
    height: 10px;
  }
`

export const ProductCountBadge = styled.div`
  position: absolute;
  top: -7px;
  right: -7px;

  border-radius: var(--radius-brand);
  border: 2px solid var(--border-active-invert);
  background: var(--bg-primary-invert);
  display: flex;
  padding: 0 var(--space-100);
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: var(--space-250);

  color: var(--text-primary-invert);
  font-size: var(--font-size-200);
  font-weight: var(--font-weight-semibold);
  line-height: var(--font-line-height-200);
  min-height: 20px;
  pointer-events: none;
`

export const ThumbnailWrapper = styled.div`
  position: relative;
  display: inline-block;

  &:hover ${HoverTooltip}, ${HoverTooltip}:hover {
    opacity: 1;
    visibility: visible;
    pointer-events: auto;
  }
`
